function PasswordResetController() {
  'ngInject';

  //Display Password Reset Modal
  jQuery(document).ready(function ($) {
      $('#modal').show();
      $('#password-reset-form').fadeIn(500);
  });

};

export default {
  name: 'passwordresetCTRL',
  fn: PasswordResetController
}